<template>
  <section class="has-listing-table">
    <div class="level no-margin">
      <revise-scheme-deadline
        @confirm="viewConfirm"
        @cancel="viewCancel"
        :is-active="isModalActive"
        :checkedRows="checkedData"
        :isAllChecked="isCheckedAll"
        :filters="query"
      >
      </revise-scheme-deadline>
      <date-of-delivering-final-dataset
        @confirm="viewConfirmDoD"
        @cancel="viewCancel"
        :is-active="isDoDModalActive"
        :checkedRows="checkedData"
        :filters="query"
        :checkedAll="isCheckedAll"
      >
      </date-of-delivering-final-dataset>
      <reporting-tracker-bulk-export
        @confirm="viewConfirmExport"
        @cancel="viewCancel"
        :is-active="isBulkExportModal"
        :customers="customers"
      >
      </reporting-tracker-bulk-export>
      <reporting-responsible-bulk
        @viewConfirm="bulkResponsibleConfirm"
        :is-active="isResponsibleModalActive"
        :filters="query"
        :checkedAll="isCheckedAll"
        :checkedRows="checkedData"
        @cancel="bulkResponsibleCancel"
        :users="userListRR"
      >
      </reporting-responsible-bulk>
      <add-comments-bulk
        @viewConfirm="bulkCommentConfirm"
        :is-active="isCommentModalActive"
        :checkedRows="checkedData"
        :filters="query"
        :checkedAll="isCheckedAll"
        @cancel="bulkCommentCancel"
      >
      </add-comments-bulk>
      <workflow-status-bulk
        @viewConfirm="bulkStatusConfirm"
        :is-active="isStatusModalActive"
        :checkedRows="checkedData"
        :filters="query"
        :checkedAll="isCheckedAll"
        @cancel="bulkStatusCancel"
      >
      </workflow-status-bulk>
      <div class="level-left bulk-actions">
        <b-dropdown v-if="!bulkActionsTemporarilyDisabled">
          <span slot="trigger" class="navbar-item">
            <a>Remind Selected</a>
          </span>
        </b-dropdown>
        <span slot="trigger" class="navbar-item">
          <a
            @click.prevent="additionalBulkCheck('exportReport')"
            data-cy="rt-bulk-exprot"
            >Export</a
          >
        </span>

        <span slot="trigger" class="navbar-item" v-if="!viewOnlyUser">
          <a
            data-cy="rt-download-PoS"
            @click.prevent="additionalBulkCheck('exportPos')"
            >Download PoS</a
          >
        </span>
        <b-dropdown
          b-dropdown
          :triggers="['hover']"
          aria-role="list"
          v-if="canEditRecord && !viewOnlyUser"
        >
          <template #trigger>
            <a class="navbar-item" role="button">
              <span>More</span>
              <b-icon icon="menu-down"></b-icon>
            </a>
          </template>

          <b-dropdown-item
            @click="additionalBulkCheck('updateReportingResponsible')"
            data-cy="bulk-reporting-responsible"
          >
            <a> Change Reporting Responsible </a>
          </b-dropdown-item>

          <b-dropdown-item
            @click="additionalBulkCheck('updateWorkflowStatus')"
            data-cy="bulk-change-status"
          >
            <a> Change Status </a>
          </b-dropdown-item>
          <b-dropdown-item
            @click="additionalBulkCheck('addBulkComments')"
            data-cy="bulk-change-comment"
          >
            <a> Add comments </a>
          </b-dropdown-item>

          <b-dropdown-item
            @click="additionalBulkCheck('addReviseSchemeDate')"
            data-cy="bulk-revised-deadline"
          >
            <a> Revised Scheme Deadline </a>
          </b-dropdown-item>

          <b-dropdown-item
            @click="additionalBulkCheck('addDateOfDeliveringFinalDataset')"
            data-cy="bulk-dod-dataset"
          >
            <a> DoD Final Dataset </a>
          </b-dropdown-item>
          <b-dropdown-item
            @click="additionalBulkCheck('exportBulkReportingTrackerData')"
            data-cy="bulk-complete-tracker-export"
          >
            <a> Complete Tracker Export </a>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="level-right page-configs">
        <div class="level current-report-default-view no-margin">
          <div class="level-left current-report-default-view-with-icon">
            <span class="current-report-default-view-text">
              <b-field label="Current Reports View"></b-field>
            </span>
            <span class="additonal-info">
              <b-tooltip
                label="All reports of current month assigned to the logged in user plus the incomplete reports from past periods"
                type="is-primary is-light"
                position="is-top"
                multilined
                data-cy="rt-additonal-info"
              >
                <i class="mdi mdi-information" />
              </b-tooltip>
            </span>
          </div>
          <div class="level-right">
            <b-switch
              name="default_view"
              :checked="true"
              @input="showDefaultView"
              v-model="currentReportDefaultView"
              class="current-report-default-view-switch"
              data-cy="rt-switch-reports"
            />
          </div>
        </div>
        <div
          class="level current-report-default-view no-margin pl-4"
          v-if="!viewOnlyUser && !isExtertenal"
        >
          <div class="level-left current-report-default-view-with-icon">
            <span class="current-report-default-view-text">
              <b-field label="My Customers"></b-field>
            </span>
            <span class="additonal-info">
              <b-tooltip
                label="Shows data of customers where logged in user is added as CAM or Back-up CAM"
                type="is-primary is-light"
                position="is-left"
                multilined
                data-cy="rt-additonal-info"
              >
                <i class="mdi mdi-information" />
              </b-tooltip>
            </span>
          </div>
          <div class="level-right">
            <b-switch
              name="my_customers"
              @input="showCamUserView"
              v-model="showCamUserData"
              :disabled="currentReportDefaultView"
              class="current-report-default-view-switch"
              data-cy="rt-switch-my-customers"
            />
          </div>
        </div>
        <b-dropdown position="is-bottom-left">
          <template #trigger>
            <a class="navbar-item navbar-mdi-tune-dropdown" slot="trigger">
              <button class="button" data-cy="rt-config-button">
                <span class="mdi mdi-table-cog mdi-24px mdi-dark"></span>
              </button>
            </a>
          </template>
          <form>
            <div class="filter-config-modal-body">
              <section class="filter-config-list">
                <span>
                  <b-field label="Column Configuration"></b-field>
                </span>
                <div class="control">
                  <b-dropdown-item
                    aria-role="list"
                    :focusable="false"
                    custom
                    paddingless
                  >
                    <b-checkbox @input="toggleAllColumns()" v-model="selectAll">
                      <strong>Select All</strong>
                    </b-checkbox>
                  </b-dropdown-item>
                </div>
                <div
                  v-for="(column, index) in computedColumns"
                  :key="index"
                  class="control"
                >
                  <div v-if="column.label != ''">
                    <b-dropdown-item
                      aria-role="list"
                      :focusable="false"
                      custom
                      paddingless
                    >
                      <b-checkbox @input="saveField()" v-model="column.visible">
                        {{ column.label }}
                      </b-checkbox>
                    </b-dropdown-item>
                  </div>
                </div>
              </section>
            </div>
          </form>
        </b-dropdown>
      </div>
    </div>
    <div class="enable-select-text">
      <circul8-table
        @clickcheck="checkCheckBox"
        @checkedAll="checkedAllData"
        :records="data"
        :fields="computedColumns"
        :linkEdit="linkEdit"
        :linkView="linkView"
        :showEditButton="!viewOnlyUser"
        :isViewOnly="viewOnlyUser"
        :checkedRows="checkedRows"
        :defaultSortColumn="customer_name"
        @downloadFile="downloadProof"
        @querySet="searchByFilter"
        @backendSort="sortData"
        :backendSortingEnabled="true"
        :allCountries="countries"
        :allCustomers="mainCustomers"
        :allCAMs="userListCAM"
        :allRRs="userListRR"
        :listingComponent="true"
        :tableName="tblName"
        :maxTextLength="'34'"
        :saveDataFields="true"
        :rowClickable="true"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
        :isLoading="isLoading"
        :isExtertenal="isExtertenal"
        @customerSelectionChanged="updateParentCustomerOptions"
      />
    </div>
    <div class="records-displayed" v-if="displayedRecords && totalRecords > 0">
      <span v-if="isCheckedAll">
        All selected,
      </span>
      <span v-if="checkedData.length > 0 && !isCheckedAll"
        >{{ checkedData.length }} selected,
      </span>
      <span v-if="currentPage * 50 + 50 < totalRecords"
        >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
        {{
          currentPage > 0
            ? nextPageCursor
              ? currentPage * 50 - 50 + data.length
              : totalRecords
            : data.length
        }}
        records out of {{ totalRecords }} records</span
      >
      <div v-else>
        <span v-if="currentPage == 0">
          displaying 0 - {{ totalRecords }} records out of
          {{ totalRecords }} records
        </span>
        <span v-else>
          displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
          out of {{ totalRecords }} records
        </span>
      </div>
    </div>
    <b-loading
      :is-full-page="true"
      v-model="isDataLoading"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import ReviseSchemeDeadline from "../../components/Reportingtracker/ReviseSchemeDeadline";
import ReportingResponsibleBulk from "../../components/Reportingtracker/ReportingResponsibleBulk";
import WorkflowStatusBulk from "../../components/Reportingtracker/WorkflowStatusBulk";
import AddCommentsBulk from "../../components/Reportingtracker/AddCommentsBulk";
import DateOfDeliveringFinalDataset from "../../components/Reportingtracker/DateOfDeliveringFinalDataset";
import CustomerUploadService from "../../services/CustomerUploadService";

import { Permission } from "../../services/Permissions";
import { AuthService } from "@/services/AuthService";
import Circul8Table from "../../components/Circul8Table.vue";
import ReportingTrackerBulkExport from "./ReportingTrackerBulkExport.vue";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { UserGroup } from "@/services/UserGroups";

// @group Reporting Tracker
export default {
  name: "ReportingTrackeList",
  mixins: [UserPermissionMixin, UtilityMixin, ScopeMixin],
  components: {
    ReviseSchemeDeadline,
    ReportingResponsibleBulk,
    WorkflowStatusBulk,
    AddCommentsBulk,
    Circul8Table,
    DateOfDeliveringFinalDataset,
    ReportingTrackerBulkExport
  },

  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 2020-11-27, gf: Franziska wants bulk actions to be hidden as long as none is implemented
      selectAll: true,
      checkedData: [],
      isDataLoading: false,
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      bulkActionsTemporarilyDisabled: true,
      authService: new AuthService(),
      reportingTrackerService: new ReportingTrackerDataService(),
      customerDataService: new CustomerProfileDataService(),
      customerUploadService: new CustomerUploadService(),
      isModalActive: false,
      isDoDModalActive: false,
      isBulkExportModal: false,
      isResponsibleModalActive: false,
      isStatusModalActive: false,
      isCommentModalActive: false,
      viewObject: {},
      customer_name: null,
      editObject: null,
      data: [],
      canEditRecord: false,
      linkEdit: "reportingtracker.edit",
      linkView: "reportingtracker.view",
      checkedRows: [],
      records: [],
      reporting_types: ["B2B", "B2C"],
      users: [],
      userMap: {},
      customers: [],
      mainCustomers: [],
      customerEntities: [],
      customerMap: {},
      customerRRMap: {},
      merchantIdMap: {},
      userListCAM: [],
      userListRR: [],
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      currentReportDefaultView: true,
      showCamUserData: false,
      switchCustomerViewEnabled: false,
      switchCustomerId: null,
      tblName: "ReportingTracker",
      displayedRecords: 0,
      totalRecords: 0,
      isLoading: true,
      nextData: false,
      previousData: false,
      currentPage: 0,
      historyData: [],
      // Below glabal variable `query` is used for serach filter, sorting and also for default view.
      // So if you make any changes to this consider testing search filter, sorting and default view as well
      query: "",
      isExtertenal: false,
      columns: [
        {
          field: "r_id",
          label: "ID",
          searchable: true,
          visible: true,
          sticky: true,
          type: "input",
          filterKey: { r_id: "" }
        },
        {
          field: "customer_name",
          label: "Customer Name",
          searchable: true,
          width: "200",
          type: "multiSelectFilter",
          visible: true,
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "additional_info",
          allStatusVals: this.mainCustomers,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { customer_name: [] }
        },
        {
          field: "parent_customer_id",
          label: "Local Entity",
          searchable: true,
          width: "200",
          type: "multiSelectFilter",
          visible: true,
          allStatusVals: this.customerEntities,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { parent_customer_id: [] }
        },
        {
          field: "customer_type",
          label: "Customer Type",
          type: "multiSelectFilter",
          width: "350",
          searchable: true,
          visible: true,
          initStatusVals: [],
          excludeForExternalUser: true,
          allStatusVals: [
            { name: "Small Customer" },
            {
              name: "Small - EuropePlus Customer"
            },
            {
              name: "Small - Flat Rate Customer"
            },
            { name: "Large Customer" }
          ],
          filterKey: { customer_type: [], field_name: "name" }
        },
        {
          field: "country",
          label: "Country",
          searchable: true,
          width: "200",
          visible: true,
          searchKey: "country",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: this.countries,
          filterKey: { country: [] }
        },
        {
          field: "stream",
          label: "Stream",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.stream,
          filterKey: { stream: [] }
        },
        {
          field: "scheme",
          label: "Scheme",
          type: "input",
          width: "200",
          searchable: true,
          visible: true,
          filterKey: { scheme: "" }
        },
        {
          field: "report_type",
          label: "Report Type",
          type: "input",
          width: "200",
          searchable: true,
          visible: true,
          filterKey: { report_type: "" },
          class: "reporting-tracker-wide-column"
        },
        {
          field: "period",
          label: "Period",
          type: "input",
          width: "150",
          searchable: true,
          visible: true,
          filterKey: { period: "" }
        },
        {
          field: "planned_scheme_deadline",
          label: "Scheme Deadline",
          width: "200",
          searchable: true,
          visible: true,
          type: "dateField",
          dateField: true,
          dateFilterKey: "planned_scheme_deadline_key",
          filterKey: { planned_scheme_deadline: [] }
        },
        {
          field: "revised_scheme_deadline",
          label: "Revised Scheme Deadline",
          width: "200",
          searchable: true,
          visible: true,
          dateField: true,
          type: "dateField",
          dateFilterKey: "revised_scheme_deadline_key",
          filterKey: { revised_scheme_deadline: [] }
        },
        {
          field: "final_dataset_delivery_date",
          label: "Delivering Final Dataset",
          width: "200",
          searchable: true,
          visible: true,
          dateField: true,
          type: "dateField",
          dateFilterKey: "final_dataset_delivery_date_key",
          filterKey: { final_dataset_delivery_date: [] }
        },
        {
          field: "customer_account_manager",
          label: "Customer Account Manager",
          type: "multiSelectFilter",
          width: "350",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.userListCAM,
          filterKey: { customer_account_manager: [] }
        },
        {
          field: "reporting_responsible",
          label: "Reporting Responsible",
          type: "multiSelectFilter",
          width: "350",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.userListRR,
          excludeForExternalUser: true,
          filterKey: { reporting_responsible: [] }
        },
        {
          field: "frequency",
          label: "Reporting Frequency",
          width: "250",
          class: "reporting-tracker-wide-column",
          searchable: true,
          visible: true,
          searchKey: "frequency",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: [
            { name: "Bi-monthly" },
            { name: "Monthly" },
            { name: "Quarterly" },
            { name: "Bi-annually" },
            { name: "Annually" },
            { name: "One-off/other (see additional information)" }
          ],
          filterKey: {
            frequency: [],
            field_name: "name"
          }
        },
        {
          field: "status",
          label: "Status",
          width: "200",
          searchable: true,
          visible: true,
          searchKey: "status",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: [
            { name: "New" },
            { name: "Raw data requested" },
            { name: "Raw data received" },
            { name: "In query/awaiting info" },
            { name: "Work in progress" },
            { name: "Awaiting approval" },
            { name: "Ready to submit" },
            { name: "Report not required" },
            { name: "Correction of data needed" },
            { name: "Submitted" },
            { name: "Submitted by customer" },
            { name: "Submitted Zero Submission" },
            { name: "No TD from customer" }
          ],
          filterKey: {
            status: [],
            field_name: "name"
          }
        },
        {
          field: "resubmitted",
          label: "Resubmitted",
          width: "200",
          searchable: true,
          visible: true,
          searchKey: "resubmitted",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          excludeForExternalUser: true,
          initStatusVals: [],
          allStatusVals: [
            { name: "Customer Incorrect" },
            { name: "Reporting Responsible Incorrect" }
          ],
          filterKey: {
            resubmitted: [],
            field_name: "name"
          },
          class: "reporting-tracker-wide-column"
        },
        {
          field: "date_of_resubmission",
          label: "Resubmission Date",
          width: "200",
          searchable: true,
          visible: true,
          type: "dateField",
          dateField: true,
          excludeForExternalUser: true,
          dateFilterKey: "date_of_resubmission_key",
          filterKey: { date_of_resubmission: [] }
        },
        {
          field: "actual_submission_date",
          label: "Actual Submission Date",
          width: "200",
          searchable: true,
          visible: true,
          type: "dateField",
          dateField: true,
          dateFilterKey: "actual_submission_date_key",
          filterKey: { actual_submission_date: [] }
        },
        {
          field: "proof_of_submission",
          label: "Proof of Submission",
          type: "input",
          width: "400",
          searchable: true,
          visible: true,
          download: true,
          downloadIcon: "mdi mdi-download",
          filterKey: { proof_of_submission: "" }
        },
        {
          field: "landbell_entity",
          label: "Landbell Entity",
          width: "200",
          searchable: true,
          visible: true,
          excludeForExternalUser: true,
          searchKey: "landbell_entity",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: [
            { name: " " },
            { name: "H2C" },
            { name: "SAS" },
            { name: "LB" },
            { name: "UK" },
            { name: "Topengi" },
            { name: "Amazon Marketplace" },
            { name: "General Marketplace" },
            { name: "ERP UK" }
          ],
          filterKey: {
            landbell_entity: [],
            field_name: "name"
          }
        },
        {
          field: "merchant_id",
          label: "Merchant Id",
          width: "300",
          searchable: true,
          type: "input",
          visible: true,
          excludeForExternalUser: true,
          filterKey: { merchant_id: "" }
        },
        {
          field: "comments",
          label: "Comments",
          searchable: true,
          type: "input",
          visible: true,
          excludeForExternalUser: true,
          filterKey: { comments: "" },
          class: "reporting-tracker-wide-column"
        },
        {
          field: "comments_external",
          label: "External Comments",
          searchable: true,
          type: "input",
          visible: true,
          excludeForExternalUser: true,
          filterKey: { comments: "" },
          class: "reporting-tracker-wide-column"
        },
        {
          field: "comments_external",
          hideForAdmin: true,
          label: "Comments",
          searchable: true,
          type: "input",
          visible: true,
          filterKey: { comments: "" },
          class: "reporting-tracker-wide-column"
        },
        {
          field: "uploaded_document",
          label: "Uploaded Data",
          type: "input",
          width: "400",
          searchable: true,
          visible: true,
          download: true,
          downloadIcon: "mdi mdi-download",
          filterKey: { uploaded_document: "" }
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          sortable: 1,
          filterKey: { actions: "" }
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal",
      "mappedCustomer"
    ]),
    viewObjectName() {
      return this.viewObject || {};
    },
    editObjectName() {
      if (this.editObject) {
        return this.editObject;
      }

      return null;
    },
    selectedCustomers() {
      // Only return if the indices are defined
      if (
        this.customerIndex !== undefined &&
        this.columns &&
        this.columns[this.customerIndex]
      ) {
        return this.columns[this.customerIndex].filterKey.customer_name;
      }
      return [];
    },
    viewOnlyUser() {
      return this.userGroups.includes(UserGroup.VIEW_ONLY);
    },
    computedColumns() {
      // Report tracker table columns differ for internal and external users
      if (this.userExternalCheck() || this.switchCustomerViewEnabled) {
        // return this.columns.filter((col) => !col.excludeForExternalUser);
        const newColumns = [];
        this.columns.forEach(col => {
          if (col.additionalInfo) {
            col.additionalInfo = false;
          }
          if (!col.excludeForExternalUser) {
            newColumns.push(col);
          }
        });
        return newColumns;
      } else {
        const newColumns = [];
        this.columns.forEach(col => {
          if (!col.hideForAdmin) {
            newColumns.push(col);
          }
        });
        return newColumns;
      }
    }
  },
  watch: {
    users(newValue) {
      this.assignUsersInDropdown(newValue);
    },
    customers(newValue) {
      this.fetchCustomersProfileData(newValue);
    },
    // Replace the complex path watcher with this:
    selectedCustomers: {
      handler(newSelectedCustomers) {
        if (this.parentCustomerIndex !== undefined) {
          this.updateParentCustomerOptions(newSelectedCustomers);
        }
      },
      deep: true
    }
  },
  mounted() {
    this.isLoading = true;
    // Disable download and edit for view-only users
    if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
      const proofOfSubmissionIndex = this.find_column_index(
        "proof_of_submission"
      );
      if (proofOfSubmissionIndex !== -1) {
        this.columns[proofOfSubmissionIndex].download = false;
      }
      const uploadedDocumentIndex = this.find_column_index("uploaded_document");
      if (uploadedDocumentIndex !== -1) {
        this.columns[uploadedDocumentIndex].download = false;
      }
      // Hide edit button for view-only users
      this.linkEdit = "";
    }
    //check if the user is switch customer or not. if so then save the customer id
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    //check if the user is external or switch
    if (this.userExternalCheck() || this.switchCustomerViewEnabled) {
      this.isExtertenal = true;
    }
    //check if there is saved columns in local storage for all user except external. if so then get it from there
    if (
      !this.isExtertenal &&
      localStorage.getItem(this.tblName + "SaveDataFields")
    ) {
      this.columns = JSON.parse(
        localStorage.getItem(this.tblName + "SaveDataFields")
      );
      // convert date string to object to auto populate in filter for date
      this.convertDateStringToObject();
    }
    //check if there is saved columns in local storage for external users. if so then get it from there
    if (
      this.isExtertenal &&
      localStorage.getItem(this.tblName + "SaveDataFieldsExternal")
    ) {
      this.columns = JSON.parse(
        localStorage.getItem(this.tblName + "SaveDataFieldsExternal")
      );
      // convert date string to object to auto populate in filter for date
      this.convertDateStringToObject();
    }
    // check if columns are saved in the custom configaration then fetch them
    if (localStorage.getItem("savedFields")) {
      const visibleFields = JSON.parse(localStorage.getItem("savedFields"));
      this.columns.forEach(
        c => (c.visible = visibleFields.indexOf(c.field) >= 0)
      );
    }
    // Update selectAll state after loading column visibility from localStorage
    this.updateSelectAllState();
    // Fetch all data sources
    this.fetchCountries();
    this.fetchSchemes(false);
    this.fetchContainers();
    this.fetchUserData();
    this.fetchCustomerProfileData(this.switchCustomerId);

    // Wait for all async calls to complete before fetching reporting tracker data
    setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const storedDefaultView = localStorage.getItem(
        "currentReportDefaultView"
      );
      if (storedDefaultView !== null) {
        this.currentReportDefaultView = storedDefaultView === "true";
      }
      this.query =
        "default_view" +
        "=" +
        this.currentReportDefaultView +
        "&" +
        "show_my_customers=" +
        this.showCamUserData +
        "&";
      //get the saved query from localStorage for all user except external
      if (!this.isExtertenal && localStorage.getItem(this.tblName + "Query")) {
        this.query = `${localStorage.getItem(
          this.tblName + "Query"
        )}default_view=${this.currentReportDefaultView}&show_my_customers=${
          this.showCamUserData
        }&`;
      }
      //get the saved query from localStorage for external user
      if (
        this.isExtertenal &&
        localStorage.getItem(this.tblName + "QueryExternal")
      ) {
        this.query = `${localStorage.getItem(
          this.tblName + "QueryExternal"
        )}default_view=${this.currentReportDefaultView}&show_my_customers=${
          this.showCamUserData
        }&`;
      }

      // Check for route query parameters and add them to the query
      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        const routeParams = new URLSearchParams();
        for (const [key, value] of Object.entries(this.$route.query)) {
          if (Array.isArray(value)) {
            value.forEach(v => routeParams.append(key, v));
          } else {
            routeParams.append(key, value);
          }
        }
        const routeQueryString = routeParams.toString();
        if (routeQueryString) {
          this.query = routeQueryString + "&" + this.query;
        }
      }

      // Parse saved query and populate filter keys so UI shows selected filters
      this.parseQueryAndSetFilters(this.query);

      // Initialize the customer and parent customer indices
      const customerIndex = this.find_column_index("customer_name");
      const parentCustomerIndex = this.find_column_index("parent_customer_id");

      // Add a reference to simplify the watcher and access in other methods
      this.customerIndex = customerIndex;
      this.parentCustomerIndex = parentCustomerIndex;

      // Initial update of parent customer options based on any pre-selected customers
      if (
        this.columns[customerIndex].filterKey.customer_name &&
        this.columns[customerIndex].filterKey.customer_name.length > 0
      ) {
        this.updateParentCustomerOptions(
          this.columns[customerIndex].filterKey.customer_name
        );
      }
      this.fetchReportingTrackerData(this.query, true);
    }, 1000);
  },
  methods: {
    updateParentCustomerOptions(selectedCustomers) {
      if (this.parentCustomerIndex === undefined || !this.columns) {
        return;
      }

      // If no customers are selected, show all parent customer entities
      if (!selectedCustomers || selectedCustomers.length === 0) {
        this.columns[
          this.parentCustomerIndex
        ].allStatusVals = this.customerEntities;
        return;
      }

      // Get the IDs of selected customers
      const selectedCustomerIds = selectedCustomers.map(c => c.id);

      // Filter customer entities to only show those who are children of selected customers
      const filteredEntities = this.customerEntities.filter(entity => {
        return selectedCustomerIds.includes(entity.parent_customer);
      });

      // Update the dropdown options
      this.columns[this.parentCustomerIndex].allStatusVals =
        filteredEntities.length > 0 ? filteredEntities : this.customerEntities;
    },

    additionalBulkCheck(bulkAction) {
      // show alert box for selecting more than 50 data
      let msg = "";
      if (
        bulkAction == "exportBulkReportingTrackerData" ||
        bulkAction == "exportReport" ||
        bulkAction == "exportPos"
      ) {
        if (this.isCheckedAll) {
          msg = `Are you sure you want to export all records?`;
        } else {
          msg =
            `Are you sure you want to export selected ` +
            this?.checkedData?.length +
            ` records?`;
        }
      } else {
        if (this.isCheckedAll) {
          msg = `Are you sure you want to change all records?`;
        } else {
          msg =
            `Are you sure you want to change selected ` +
            this?.checkedData?.length +
            ` records?`;
        }
      }
      if (this.checkedData.length > 50 || this.isCheckedAll) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message: msg,
          trapFocus: true,
          onConfirm: value => this.functionCallingMethod(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    functionCallingMethod(value, bulkAction) {
      switch (bulkAction) {
        case "exportReport":
          this.exportReport();
          break;
        case "exportPos":
          this.exportPos();
          break;
        case "updateReportingResponsible":
          this.updateReportingResponsible();
          break;
        case "updateWorkflowStatus":
          this.updateWorkflowStatus();
          break;
        case "addReviseSchemeDate":
          this.addReviseSchemeDate();
          break;
        case "addDateOfDeliveringFinalDataset":
          this.addDateOfDeliveringFinalDataset();
          break;
        case "exportBulkReportingTrackerData":
          this.exportBulkReportingTrackerData();
          break;
        case "addBulkComments":
          this.updateBulkComment();
          break;
      }
    },
    convertDateStringToObject() {
      /*
      string dates in local storage need to be converted to object to auto populate in filter
      */
      const planned_scheme_deadline = this.find_column_index(
        "planned_scheme_deadline"
      );
      if (
        this.columns[planned_scheme_deadline].filterKey.planned_scheme_deadline
          .length
      ) {
        this.columns[
          planned_scheme_deadline
        ].filterKey.planned_scheme_deadline[0] = new Date(
          this.columns[
            planned_scheme_deadline
          ].filterKey.planned_scheme_deadline[0]
        );
        this.columns[
          planned_scheme_deadline
        ].filterKey.planned_scheme_deadline[1] = new Date(
          this.columns[
            planned_scheme_deadline
          ].filterKey.planned_scheme_deadline[1]
        );
      }

      const revised_scheme_deadline = this.find_column_index(
        "revised_scheme_deadline"
      );
      if (
        this.columns[revised_scheme_deadline].filterKey.revised_scheme_deadline
          .length
      ) {
        this.columns[
          revised_scheme_deadline
        ].filterKey.revised_scheme_deadline[0] = new Date(
          this.columns[
            revised_scheme_deadline
          ].filterKey.revised_scheme_deadline[0]
        );
        this.columns[
          revised_scheme_deadline
        ].filterKey.revised_scheme_deadline[1] = this.convertToDateObject(
          this.columns[revised_scheme_deadline].filterKey
            .revised_scheme_deadline[1]
        );
      }

      const final_dataset_delivery_date = this.find_column_index(
        "final_dataset_delivery_date"
      );
      if (
        this.columns[final_dataset_delivery_date].filterKey
          .final_dataset_delivery_date.length
      ) {
        this.columns[
          final_dataset_delivery_date
        ].filterKey.final_dataset_delivery_date[0] = this.convertToDateObject(
          this.columns[final_dataset_delivery_date].filterKey
            .final_dataset_delivery_date[0]
        );
        this.columns[
          final_dataset_delivery_date
        ].filterKey.final_dataset_delivery_date[1] = this.convertToDateObject(
          this.columns[final_dataset_delivery_date].filterKey
            .final_dataset_delivery_date[1]
        );
      }

      const actual_submission_date = this.find_column_index(
        "actual_submission_date"
      );
      if (
        this.columns[actual_submission_date].filterKey.actual_submission_date
          .length
      ) {
        this.columns[
          actual_submission_date
        ].filterKey.actual_submission_date[0] = this.convertToDateObject(
          this.columns[actual_submission_date].filterKey
            .actual_submission_date[0]
        );
        this.columns[
          actual_submission_date
        ].filterKey.actual_submission_date[1] = this.convertToDateObject(
          this.columns[actual_submission_date].filterKey
            .actual_submission_date[1]
        );
      }
      const date_of_resubmission = this.find_column_index(
        "date_of_resubmission"
      );
      if (
        this.columns[date_of_resubmission].filterKey.date_of_resubmission.length
      ) {
        this.columns[
          date_of_resubmission
        ].filterKey.date_of_resubmission[0] = this.convertToDateObject(
          this.columns[date_of_resubmission].filterKey.date_of_resubmission[0]
        );
        this.columns[
          date_of_resubmission
        ].filterKey.date_of_resubmission[1] = this.convertToDateObject(
          this.columns[date_of_resubmission].filterKey.date_of_resubmission[1]
        );
      }
    },

    convertToDateObject(date) {
      if (date) {
        return new Date(date);
      }
    },

    checkDefaultQueryParamExists(paramValue) {
      const defaultQuery = "default_view" + "=" + paramValue + "&";
      if (this.query.includes(defaultQuery)) {
        return true;
      } else {
        return false;
      }
    },
    replaceDefaultViewParamFromQuery(value) {
      const defaultQuery = "default_view" + "=" + value + "&";

      if (this.checkDefaultQueryParamExists(true)) {
        this.query = this.query.replace(
          "default_view" + "=" + true + "&",
          defaultQuery
        );
      } else if (this.checkDefaultQueryParamExists(false)) {
        this.query = this.query.replace(
          "default_view" + "=" + false + "&",
          defaultQuery
        );
      } else {
        this.query += defaultQuery;
      }
      return this.query;
    },
    showDefaultView(value) {
      this.currentReportDefaultView = value;
      this.showCamUserData = false;
      this.data = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      // check includes and replace
      this.query = this.replaceDefaultViewParamFromQuery(value);

      // Update show_my_customers param to false
      this.query = this.query
        ? this.query.replace(/show_my_customers=[^&]*&?/g, "").replace(/&$/, "")
        : "";
      this.query = this.query + "&show_my_customers=false";

      if (this.query.includes("page=")) {
        // replace pagination page parameter from query string
        this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      }
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.PreviousPageCursor = null;
      this.displayedRecords = 0;
      this.currentPage = 0;
      this.fetchReportingTrackerData(this.query, true);
      localStorage.setItem("currentReportDefaultView", value);
    },
    showCamUserView() {
      this.data = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      // If My Customers is being toggled on, turn off Current Reports View
      if (this.showCamUserData) {
        this.currentReportDefaultView = false;
      }
      // check includes and replace
      this.query = this.query
        ? this.query.replace(/show_my_customers=[^&]*&?/g, "").replace(/&$/, "")
        : "";
      this.query = this.query + "&show_my_customers=" + this.showCamUserData;

      if (this.query.includes("page=")) {
        // replace pagination page parameter from query string
        this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      }
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.PreviousPageCursor = null;
      this.displayedRecords = 0;
      this.currentPage = 0;
      this.fetchReportingTrackerData(this.query, true);
    },
    downloadProof(data, col) {
      if (col.field == "proof_of_submission") {
        const fileName = data.proof_of_submission;
        try {
          this.reportingTrackerService.exportProofOfSubmission(
            data.id,
            fileName
          );
        } catch (e) {
          this.$buefy.dialog.alert({
            title: "Download Error !",
            message: e.message,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true
          });
        }
      }
      if (col.field == "uploaded_document") {
        const fileName = data.uploaded_document;
        try {
          this.customerUploadService.exportCustomerUpload(
            data.customer_upload_id,
            fileName,
            data.customer_id
          );
        } catch (e) {
          this.$buefy.dialog.alert({
            title: "Download Error !",
            message: e.message,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true
          });
        }
      }
    },
    // this function is called when select all/ deselect all checkbox is checked
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRows = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRows = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.data);
      }
    },
    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexs = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.data.findIndex(object => {
          return element.id === object.id;
        });
        indexs.push(index);
      });
      // create 2 dictonary. one with indexes for showing current page selected another with checked row vvalue
      this.map1.set(this.currentPage, indexs);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRows = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRows = [];
        this.map1 = new Map();
      }
    },
    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();

      const storedDefaultView = localStorage.getItem(
        "currentReportDefaultView"
      );
      if (storedDefaultView !== null) {
        this.currentReportDefaultView = storedDefaultView === "true";
      }

      filterQuery +=
        "default_view" +
        "=" +
        this.currentReportDefaultView +
        "&" +
        "show_my_customers=" +
        this.showCamUserData +
        "&";
      this.query = filterQuery;
      this.displayedRecords = 0;

      // Parse the query to get selected customers
      const customerNameFilter = this.extractCustomerFilterFromQuery(
        filterQuery
      );

      // Update parent customer options based on customer selection
      if (customerNameFilter) {
        this.updateParentCustomerOptions(
          this.columns[this.customerIndex].filterKey.customer_name
        );
      }

      let query = "";
      // Maintaining sort column & order in separate varaibles
      if (this.lastSortColumn) {
        query += "order_field" + "=" + this.lastSortColumn + "&";
        query += "order_by" + "=" + this.lastSortOrder + "&";
        query += this.query;
      } else {
        query = this.query;
      }

      this.fetchReportingTrackerData(query, true);
    },

    // Helper method to extract customer filter from query string
    extractCustomerFilterFromQuery(filterQuery) {
      // Simple check if customer_name appears in the filter query
      return filterQuery.includes("customer_name");
    },

    // Parse query string and set filter keys for all filterable columns so UI shows selected filters
    parseQueryAndSetFilters(queryString) {
      if (
        !queryString ||
        queryString === `default_view=true&` ||
        queryString === `default_view=false&` ||
        queryString === `default_view=true&show_my_customers=false&` ||
        queryString === `default_view=true&show_my_customers=true&` ||
        queryString === `default_view=false&show_my_customers=false&` ||
        queryString === `default_view=false&show_my_customers=true&`
      ) {
        return; // No filters to parse
      }

      // Parse query parameters
      const urlParams = new URLSearchParams(queryString);
      const params = {};

      for (const [key, value] of urlParams.entries()) {
        if (key === "default_view" || key === "show_my_customers") continue; // Skip default_view and show_my_customers parameters

        if (!params[key]) {
          params[key] = [];
        }
        params[key].push(value);
      }

      // Set filter keys for each column based on parsed parameters
      this.columns.forEach(column => {
        if (column.filterKey) {
          const fieldName = Object.keys(column.filterKey)[0];

          if (params[fieldName] && params[fieldName].length > 0) {
            if (Array.isArray(column.filterKey[fieldName])) {
              // Multi-select filter (array type)
              if (
                column.type === "multiSelectFilter" ||
                column.multiSelectFilter
              ) {
                // For multi-select filters, we need to find the actual objects from allStatusVals
                const selectedValues = params[fieldName];
                const selectedObjects = [];

                if (
                  column.allStatusVals &&
                  Array.isArray(column.allStatusVals)
                ) {
                  selectedValues.forEach(value => {
                    const found = column.allStatusVals.find(
                      item =>
                        item.id == value ||
                        item.name === value ||
                        item.code === value ||
                        item === value
                    );
                    if (found) {
                      selectedObjects.push(found);
                    }
                  });
                }

                if (selectedObjects.length > 0) {
                  column.filterKey[fieldName] = selectedObjects;
                }
              }
            } else {
              // Single value filter (string type)
              column.filterKey[fieldName] = params[fieldName][0];
            }
          }
        }
      });
    },
    pullNextPage() {
      this.currentPage > 1 ? (this.previousData = true) : "";
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor
        ? this.nextPageCursor.split("?")[1].split("&")
        : "";
      const query_part =
        temp &&
        temp.filter(function(value) {
          return value.indexOf("page=") == -1;
        });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.fetchReportingTrackerData(this.query, true, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query = query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchReportingTrackerData(this.query, true, "prev");
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const storedDefaultView = localStorage.getItem(
        "currentReportDefaultView"
      );
      if (storedDefaultView !== null) {
        this.currentReportDefaultView = storedDefaultView === "true";
      }

      this.query = this.replaceDefaultViewParamFromQuery(
        this.currentReportDefaultView
      );
      const oldOrderField = "order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "order_field" + "=" + field + "&";
      const newOrderValue = "order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchReportingTrackerData(this.query, true);
    },
    canEdit() {
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        this.userHasPermission(Permission.RTRACKER_REPORT_CHANGE_OWN)
      ) {
        // To check whether the user is EPR Admin or not
        this.canEditRecord = true;
      }

      return this.canEditRecord;
    },
    isEditAllowed(data) {
      let isEdit = false;
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) &&
        data.active == true
      ) {
        // To check whether the user is EPR Admin or not & data is active
        isEdit = true;
      } else if (
        data.active == true &&
        this.userHasPermission(Permission.RTRACKER_REPORT_CHANGE_OWN) &&
        (data.customer_account_manager_id == this.userId ||
          data.reporting_responsible_id == this.userId ||
          this.customerRRMap[data.customer_id] == this.userId ||
          data.backup_account_manager_id == this.userId)
      ) {
        // To check whether the user is RR or CAM & data is active
        isEdit = true;
      } else {
        isEdit = false;
      }
      data["lastUpdated"] = false;
      return isEdit;
    },
    exportReport() {
      try {
        this.reportingTrackerService
          .exportReport(
            this.checkedData.map(records => records.id),
            this.query,
            this.isCheckedAll,
            this.switchCustomerId
          )
          .subscribe(
            () => {
              this.isDataLoading = false;
            },
            e => {
              this.isDataLoading = false;
              console.log(e);
            }
          );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Export is not possible",
          message: e.message
        });
        this.isDataLoading = false;
      }
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isDataLoading = false;
    },
    exportPos() {
      try {
        this.reportingTrackerService.exportPos(
          this.checkedData.map(records => records.id),
          this.query,
          this.isCheckedAll,
          this.switchCustomerId
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Nothing to Export!",
          message: e.message
        });
      }
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRows = [];
    },
    isAdmin() {
      if (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)) {
        return true;
      }
      return false;
    },
    updateReportingResponsible() {
      if (this.checkedData.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please choose at least one record",
          type: "is-danger"
        });

        return false;
      }

      // Verify that user has permission to change Reporting Responsible for all selected rows
      if (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)) {
        this.isResponsibleModalActive = true;
      } else if (
        (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_OWN) ||
          this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER) ||
          this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE)) &&
        this.checkedData.filter(row => !row.actions).length == 0
      ) {
        this.isResponsibleModalActive = true;
      } else {
        this.$buefy.dialog.alert({
          title: "Unauthorized",
          message:
            "You can change Reporting Responsible only for reports that you are the designated CAM/RR for. For further info, please contact an EPR administrator.",
          type: "is-warning"
        });
      }
    },

    bulkResponsibleCancel() {
      this.isResponsibleModalActive = false;
    },
    bulkResponsibleConfirm(reporting_responsible) {
      this.isResponsibleModalActive = false;

      for (const c in this.checkedData) {
        this.checkedData[c].reporting_responsible = reporting_responsible;
        this.checkedData[c].reporting_responsible = this.userMap[
          reporting_responsible
        ];
      }
      this.highlightChangesInTable();
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRows = [];
    },
    updateWorkflowStatus() {
      if (this.checkedData.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please choose at least one record",
          type: "is-danger"
        });
        return false;
      }
      this.isStatusModalActive = true;
    },
    bulkStatusCancel() {
      this.isStatusModalActive = false;
    },
    bulkStatusConfirm(status, errorIds) {
      this.isStatusModalActive = false;
      for (const c in this.checkedData) {
        if (errorIds != null || errorIds != undefined) {
          if (!errorIds.includes(this.checkedData[c])) {
            this.checkedData[c].status = status;
          }
        } else {
          this.checkedData[c].status = status;
        }
      }
      this.highlightChangesInTable();
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRows = [];
    },
    updateBulkComment() {
      if (this.checkedData.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please choose at least one record",
          type: "is-danger"
        });
        return false;
      }
      this.isCommentModalActive = true;
    },
    bulkCommentCancel() {
      this.isCommentModalActive = false;
    },
    bulkCommentConfirm(comment, comment_type) {
      this.isCommentModalActive = false;
      for (const c in this.checkedData) {
        if (comment_type == "External") {
          this.checkedData[c].comments_external = comment;
        } else {
          this.checkedData[c].comments = comment;
        }
      }
      this.highlightChangesInTable();
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRows = [];
    },
    addReviseSchemeDate() {
      if (this.checkedData.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please choose at least one record."
        });
        return false;
      }
      this.isModalActive = true;
    },
    addDateOfDeliveringFinalDataset() {
      if (this.checkedData.length == 0) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please choose at least one record."
        });
        return false;
      }
      this.isDoDModalActive = true;
    },
    exportBulkReportingTrackerData() {
      this.isBulkExportModal = true;
    },
    viewModal(viewObject) {
      this.viewObject = viewObject;
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.editObject = editObject;
      this.isEditModalActive = true;
    },
    viewConfirm(schemeDeadline) {
      this.isModalActive = false;
      for (const c in this.checkedData) {
        this.checkedData[c].revised_scheme_deadline = schemeDeadline;
      }
      this.highlightChangesInTable();
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRows = [];
    },
    viewConfirmDoD(finalDatasetDeadline) {
      this.isDoDModalActive = false;
      for (const c in this.checkedData) {
        this.checkedData[c].final_dataset_delivery_date = finalDatasetDeadline;
      }
      this.highlightChangesInTable();
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRows = [];
    },
    viewConfirmExport() {
      this.isBulkExportModal = false;
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRows = [];
    },
    viewCancel() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedDataMap = new Map();
      this.isModalActive = false;
      this.isDoDModalActive = false;
      this.isBulkExportModal = false;
    },
    editCancel() {
      this.isEditModalActive = false;
    },
    /** TODO: Give self-explanatory name, e.g. createLookupMap */
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    preparemerchantIdData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["merchant_id"];
      }
      return resultDict;
    },
    prepareCustomerRRData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["reporting_responsible"];
      }
      return resultDict;
    },
    filterUsers(users, role) {
      const newUsers = [];
      for (const user of users) {
        const epradmin = user.groups.filter(e => e.name === role);
        if (epradmin.length > 0) {
          newUsers.push(user);
        }
      }
      return newUsers;
    },
    assignUsersInDropdown(newValue) {
      this.userListRR = this.filterUsers(newValue, "Reporting Responsible");
      const rrIndex = this.find_column_index("reporting_responsible");
      if (rrIndex > -1) {
        this.columns[rrIndex].allStatusVals = this.userListRR;
      }

      this.userListCAM = this.filterUsers(newValue, "Customer Account Manager");
      const camIndex = this.find_column_index("customer_account_manager");
      if (camIndex > -1) {
        this.columns[camIndex].allStatusVals = this.userListCAM;
      }
      if (this.data && this.data.length > 0) {
        for (const report in this.data) {
          const reportData = this.data[report];
          reportData["customer_account_manager"] = this.userMap[
            reportData["customer_account_manager_id"]
          ];
          reportData["reporting_responsible"] = this.userMap[
            reportData["reporting_responsible"]
          ];
        }
      }
    },

    fetchCustomersProfileData(customers) {
      this.mainCustomers = customers.filter(e => e.parent_customer == null);
      this.customerEntities = customers.filter(e => e.parent_customer != null);
      const customerIndex = this.find_column_index("customer_name");
      this.columns[customerIndex].allStatusVals = this.mainCustomers;
      const parentCustomerIndex = this.find_column_index("parent_customer_id");
      this.columns[parentCustomerIndex].allStatusVals = this.customerEntities;
      this.canEdit();
      this.customerMap = this.prepareMasterData(customers);
      this.merchantIdMap = this.preparemerchantIdData(customers);
      this.customerRRMap = this.prepareCustomerRRData(customers);
      if (this.data && this.data.length > 0) {
        for (const report in this.data) {
          const reportData = this.data[report];
          const parentCustomer = reportData["parent_customer_id"];
          reportData["merchant_id"] = this.merchantIdMap[
            reportData["customer_id"]
          ];
          if (parentCustomer != null) {
            reportData["customer_name"] = this.customerMap[
              reportData["parent_customer_id"]
            ];
          } else {
            reportData["customer_name"] = this.customerMap[
              reportData["customer_id"]
            ];
          }
          if (parentCustomer != null) {
            reportData["parent_customer_id"] = this.customerMap[
              reportData["customer_id"]
            ];
          } else {
            reportData["parent_customer_id"] = this.customerMap[
              reportData["parent_customer_id"]
            ];
          }
          if (this.userMap[reportData["customer_account_manager_id"]]) {
            reportData["customer_account_manager"] = this.userMap[
              reportData["customer_account_manager_id"]
            ];
          }
        }
      }
    },

    fetchReportingTrackerData(search = "", initialLoad = false, scrollDir) {
      this.isLoading = true;
      let query;
      this.reportingTrackerService
        .getAll((query = search), this.switchCustomerId)
        .subscribe(
          response => {
            this.PreviousPageCursor = this.nextPageCursor
              ? this.nextPageCursor
              : this.PreviousPageCursor;
            this.nextPageCursor = response["next"];
            if (this.currentPage > 1) {
              this.previousData = true;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            } else {
              this.enableLoadMore = this.previousData = false;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            }

            if (this.loadMoreClicked || initialLoad)
              this.displayedRecords += response["results"].length;
            this.totalRecords = response["count"];
            if (this.totalRecords == 0 && this.currentReportDefaultView) {
              this.showDefaultView(false);
            }
            let tempData = [];
            if (scrollDir == "next") {
              //this.totalRecords = this.data.length + response["count"];
              if (!this.nextPageCursor) {
                this.prepareData(response["results"]);
              } else {
                tempData = [...this.data, ...response["results"]];
                if (tempData.length > 100 && this.nextPageCursor != null) {
                  tempData = tempData.slice(50, 150);
                }
                this.prepareData(tempData);
              }
            } else if (scrollDir == "prev") {
              //this.totalRecords = this.data.length + response["count"];
              if (this.currentPage == 0) {
                this.prepareData(response["results"]);
              } else {
                tempData = [...response["results"], ...this.data];
                if (tempData.length >= 100) {
                  tempData = tempData.slice(0, 100);
                }
                this.prepareData(tempData);
              }
            } else {
              this.prepareData(response["results"]);
            }

            this.isLoading = false;
          },
          e => {
            this.isDataLoading = false;
            this.nextData = false;
          }
        );
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        const parentCustomer = reportData["parent_customer_id"];
        reportData["country_id"] = reportData["country"];
        reportData["stream_id"] = reportData["stream"];
        reportData["scheme_id"] = reportData["scheme"];
        reportData["merchant_id"] = this.merchantIdMap[
          reportData["customer_id"]
        ];
        if (parentCustomer != null) {
          reportData["customer_name"] = reportData["customer_name"]
            ? reportData["customer_name"]
            : this.customerMap[reportData["parent_customer_id"]];
        } else {
          reportData["customer_name"] = this.customerMap[
            reportData["customer_id"]
          ];
        }
        if (parentCustomer != null) {
          reportData["parent_customer_id"] = this.customerMap[
            reportData["customer_id"]
          ];
        } else {
          reportData["parent_customer_id"] = this.customerMap[
            reportData["parent_customer_id"]
          ];
        }
        if (this.userMap[reportData["customer_account_manager_id"]]) {
          reportData["customer_account_manager"] = this.userMap[
            reportData["customer_account_manager_id"]
          ];
        }
        reportData["reporting_responsible_id"] =
          reportData["reporting_responsible"];
        if (this.userMap[reportData["reporting_responsible"]]) {
          reportData["reporting_responsible"] = this.userMap[
            reportData["reporting_responsible"]
          ];
        }
        if (reportData["proof_of_submission"] != null) {
          const proofOfSubmission = reportData["proof_of_submission"].split(
            "|"
          );
          reportData["number_of_downloadable_file"] = proofOfSubmission.length;
          reportData["proof_of_submission_file_count"] =
            proofOfSubmission.length;
          if (proofOfSubmission.length > 1) {
            reportData[
              "proof_of_submission"
            ] = `${proofOfSubmission.length} files are uploaded`;
          } else {
            try {
              reportData["proof_of_submission"] = decodeURIComponent(
                proofOfSubmission[0].substring(
                  proofOfSubmission[0].lastIndexOf("/") + 1
                )
              );
            } catch (e) {
              reportData[
                "proof_of_submission"
              ] = proofOfSubmission[0].substring(
                proofOfSubmission[0].lastIndexOf("/") + 1
              );
            }
          }
        }
        if (reportData["uploaded_document"] != null) {
          const uploadedDocument = reportData["uploaded_document"].split("|");
          reportData["uploaded_document_file_count"] = uploadedDocument.length;
          if (uploadedDocument.length > 1) {
            reportData[
              "uploaded_document"
            ] = `${uploadedDocument.length} files are uploaded`;
          } else {
            try {
              reportData["uploaded_document"] = decodeURIComponent(
                uploadedDocument[0].substring(
                  uploadedDocument[0].lastIndexOf("/") + 1
                )
              );
            } catch (e) {
              reportData["uploaded_document"] = uploadedDocument[0].substring(
                uploadedDocument[0].lastIndexOf("/") + 1
              );
            }
          }
        }
        reportData["country"] =
          typeof reportData["country"] == "number"
            ? this.countryMap[reportData["country"]]
            : reportData["country"];
        reportData["stream"] =
          typeof reportData["stream"] == "number"
            ? this.containerMap[reportData["stream"]]
            : reportData["stream"];
        reportData["scheme"] =
          typeof reportData["scheme"] == "number"
            ? this.schemeMap[reportData["scheme"]]
            : reportData["scheme"];
        reportData["actions"] = true;

        dataList.push(reportData);
      }
      if (this.nextPageCursor == null) {
        this.data.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.data = dataList;
      }
      if (
        this.$route.query.id !== undefined &&
        this.$route.query.id !== "" &&
        !isNaN(this.$route.query.id)
      ) {
        const pos = this.data.findIndex(e => e.id == this.$route.query.id);

        if (pos >= 0) {
          const lastUpdatedRecord = this.data[pos];
          lastUpdatedRecord.lastUpdated = true;
          // remove the last updated record
          this.data.splice(pos, 1);
          // add it back to the top
          this.data.splice(0, 0, lastUpdatedRecord);
        }
      }
      //if select all checkbox clicked the show all the data for the page as checked
      if (this.isCheckedAll) {
        this.checkedRows = this.data;
      } else {
        //else show the corresponding data from the dictionay map1
        const temp = [];
        // check if dictionary has value or not
        if (
          this.map1.get(this.currentPage) &&
          this.map1.get(this.currentPage).length > 0
        ) {
          //inserting data according to index of the current page
          this.map1.get(this.currentPage).forEach(element => {
            temp.push(this.data[element]);
          });
          this.checkedRows = temp;
        } else {
          this.checkedRows = [];
        }
      }
    },
    highlightChangesInTable() {
      const checked = this.checkedData.map(records => records.id);
      for (let i = 0; i < checked.length; i++) {
        const pos = this.data.findIndex(e => e.id == checked[i]);
        const lastUpdatedRecord = this.data[pos];
        lastUpdatedRecord.lastUpdated = true;
        // remove the last updated record
        this.data.splice(pos, 1);
        // add it back to the top
        this.data.splice(0, 0, lastUpdatedRecord);
      }
    },
    saveField() {
      localStorage.setItem(
        "savedFields",
        JSON.stringify(this.columns.filter(c => c.visible).map(c => c.field))
      );
      // Update selectAll state based on whether all columns are visible
      this.updateSelectAllState();
    },
    toggleAllColumns() {
      this.columns.forEach(column => {
        if (column.field !== "actions") {
          column.visible = this.selectAll;
        }
      });
      this.saveField();
    },
    updateSelectAllState() {
      // Check if all non-actions columns are visible
      const visibleColumns = this.columns.filter(
        column => column.field !== "actions"
      );
      const allVisible = visibleColumns.every(column => column.visible);
      this.selectAll = allVisible;
    }
  }
};
</script>
